// this.$store.state.user
// await this.$store.dispatch("doLogout");
// await this.$store.dispatch("doLogin", user);

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const IMAGE_DIR = "/images/espaco/gallery/";
const IMAGES = [
  "36",
  "37",
  "38",
  "39",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  // "08",
  // "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  // "25",
  // "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35"
];

const CAMPANHAS = [
  {
    title: "Coepad",
    image: "/downloads/campanhas/coepad.jpg",
    big: "/downloads/campanhas/coepad.png",
    file: "/downloads/campanhas/coepad_27x50cm.pdf"
  },
  {
    title: "Ecopet",
    image: "/downloads/campanhas/ecopet.jpg",
    big: "/downloads/campanhas/ecopet.png",
    file: "/downloads/campanhas/ecopet_27x50cm.pdf"
  },
  {
    title: "Esponjas",
    image: "/downloads/campanhas/esponjas.png",
    big: "/downloads/campanhas/esponjas.png",
    file: "/downloads/campanhas/esponja_27x50cm.pdf"
  },
  {
    title: "Meias",
    image: "/downloads/campanhas/meias.jpg",
    big: "/downloads/campanhas/meias.png",
    file: "/downloads/campanhas/meias_27x50cm.pdf"
  },
  {
    title: "Lacres",
    image: "/downloads/campanhas/lacre2.jpg",
    big: "/downloads/campanhas/lacre2.jpg",
    file: "/downloads/campanhas/lacre_solidario.jpg"
  },
  {
    title: "Pilhas",
    image: "/downloads/campanhas/pilhas.jpg",
    big: "/downloads/campanhas/pilhas.png",
    file: "/downloads/campanhas/pilhas.jpg"
  },
  {
    title: "ReÓleo",
    image: "/downloads/campanhas/reoleo.png",
    big: "/downloads/campanhas/reoleo.png",
    file: "/downloads/campanhas/reoleo.jpg"
  }
];

export default new Vuex.Store({
  state: {
    calendarios: [
      {
        icon: "calendar_today",
        // link: "javascript:alert('Disponível em breve.')",
        link: "/downloads/Calendario2026.pdf",
        text: "2026",
        // color: "orange darken-2",
        color: "blue darken-1",
        message: ""
      },
      {
        icon: "calendar_today",
        link: "/downloads/Calendario2027.pdf",
        text: "2027",
        color: "orange lighten-2",
        message: ""
      }
      // {
      //   icon: "calendar_today",
      //   link: "/downloads/Calendario2019.pdf",
      //   text: "2019",
      //   color: "blue darken-1",
      // },
    ],
    endereco: {
      rua: "Rua Valdomiro José Vieira, 94",
      bairro: "Campeche",
      cidade: "Florianópolis",
      uf: "SC",
      cep: "88063-035"
    },
    maps: "https://goo.gl/maps/zQjrtyz2h9eyz6gq7",
    waze:
      "https://www.waze.com/ul?ll=-27.67941400%2C-48.49732100&navigate=yes&zoom=16",
    email: "engenho@escolaengenho.com.br",
    materiais: [
      {
        title: "1º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-1-ANO-2026.pdf?v=1",
        tipo: 2
      },
      {
        title: "2º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-2-ANO-2026.pdf?v=1",
        tipo: 2
      },
      {
        title: "3º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-3-ANO-2026.pdf?v=1",
        tipo: 2
      },
      {
        title: "4º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-4-ANO-2026.pdf?v=1",
        tipo: 2
      },
      {
        title: "5º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-5-ANO-2026.pdf?v=1",
        tipo: 2
      },
      {
        title: "6º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-6-ANO-2026.pdf?v=1",
        tipo: 3
      },
      {
        title: "7º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-7-ANO-2026.pdf?v=1",
        tipo: 3
      },
      {
        title: "8º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-8-ANO-2026.pdf?v=1",
        tipo: 3
      },
      {
        title: "9º",
        link: "/downloads/materiais-v1/LISTA-MATERIAL-9-ANO-2026.pdf?v=1",
        tipo: 3
      }
    ],
    outdoors: [
      {
        title: "Outdoor 2024 - tipo 1",
        lg: "/images/outdoor/2024-1-lg.jpg",
        sm: "/images/outdoor/2024-1-sm.jpg"
      },
      {
        title: "Outdoor 2024 - tipo 2",
        lg: "/images/outdoor/2024-2-lg.jpg",
        sm: "/images/outdoor/2024-2-sm.jpg"
      },
      {
        title: "Outdoor 2024 - tipo 3",
        lg: "/images/outdoor/2024-3-lg.jpg",
        sm: "/images/outdoor/2024-3-sm.jpg"
      },
      {
        title: "Outdoor 2024 - tipo 4",
        lg: "/images/outdoor/2024-4-lg.jpg",
        sm: "/images/outdoor/2024-4-sm.jpg"
      },
      {
        title: "Outdoor 2024 - tipo 5",
        lg: "/images/outdoor/2024-5-lg.jpg",
        sm: "/images/outdoor/2024-5-sm.jpg"
      },
      {
        title: "Outdoor 2024 - tipo 6",
        lg: "/images/outdoor/2024-6-lg.jpg",
        sm: "/images/outdoor/2024-6-sm.jpg"
      },
      {
        title: "Outdoor 2023 - tipo 1",
        lg: "/images/outdoor/2023-1-lg.jpg",
        sm: "/images/outdoor/2023-1-sm.jpg"
      },

      {
        title: "Outdoor 2022 - tipo 2",
        lg: "/images/outdoor/2022-5-lg.jpg",
        sm: "/images/outdoor/2022-5-sm.jpg"
      },
      {
        title: "Outdoor 2022 - tipo 1",
        lg: "/images/outdoor/2022-4-lg.jpg",
        sm: "/images/outdoor/2022-4-sm.jpg"
      },

      {
        title: "Outdoor 2021 - tipo 1",
        lg: "/images/outdoor/2021-1-lg.jpg",
        sm: "/images/outdoor/2021-1-sm.jpg"
      },

      {
        title: "Outdoor 2020 - tipo 1",
        lg: "/images/outdoor/2020-1-lg.jpg",
        sm: "/images/outdoor/2020-1-sm.jpg"
      },
      {
        title: "Outdoor 2019 - tipo 1",
        lg: "/images/outdoor/2019-1-lg.jpg",
        sm: "/images/outdoor/2019-1-sm.jpg"
      },
      {
        title: "Outdoor 2019 - tipo 2",
        lg: "/images/outdoor/2019-2-lg.jpg",
        sm: "/images/outdoor/2019-2-sm.jpg"
      },
      {
        title: "Outdoor 2018 - tipo 1",
        lg: "/images/outdoor/2018-1-lg.jpg",
        sm: "/images/outdoor/2018-1-sm.jpg"
      },
      {
        title: "Outdoor 2018 - tipo 2",
        lg: "/images/outdoor/2018-2-lg.jpg",
        sm: "/images/outdoor/2018-2-sm.jpg"
      },
      {
        title: "Outdoor 2017 - tipo 1",
        lg: "/images/outdoor/2017-2-lg.jpg",
        sm: "/images/outdoor/2017-2-sm.jpg"
      },
      {
        title: "Outdoor 2016 - tipo 1",
        lg: "/images/outdoor/2016-1-lg.jpg",
        sm: "/images/outdoor/2016-1-sm.jpg"
      },
      {
        title: "Outdoor 2016 - tipo 2",
        lg: "/images/outdoor/2016-2-lg.jpg",
        sm: "/images/outdoor/2016-2-sm.jpg"
      },
      {
        title: "Outdoor 2015 - tipo 1",
        lg: "/images/outdoor/2015-1-lg.jpg",
        sm: "/images/outdoor/2015-1-sm.jpg"
      }
    ],
    sociais: [
      {
        icon: "fab fa-facebook",
        link: "https://www.facebook.com/escolaengenhocampeche",
        text: "Curta no Facebook",
        color: "blue lighten-1"
      },
      {
        icon: "fab fa-instagram",
        link: "https://www.instagram.com/escolaengenho",
        text: "Siga no Instagram",
        color: "purple lighten-2"
      },
      {
        icon: "fab fa-whatsapp",
        link:
          "https://wa.me/5548999226535?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20%20site%20da%20escola.",
        text: "Fale pelo WhatsApp",
        color: "green lighten-1"
      }
    ],
    telefones: [
      { tipo: "Fixo", numero: "(48) 3237-2410" },
      {
        tipo: "Celular",
        numero: "(48) 98805-8518",
        whatsapp:
          "https://wa.me/5548988058518?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20site%20da%20Escola%20Engenho."
      },
      {
        tipo: "Celular",
        numero: "(48) 99630-0608",
        whatsapp:
          "https://wa.me/5548996300608?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20site%20da%20Escola%20Engenho."
      }
    ],
    tematicas: [
      {
        key: "default",
        link: null,
        logo: "/tematica/default/logo.svg",
        bg: "/tematica/default/bg.jpg"
      },
      {
        key: "junina",
        link: null,
        logo: "/tematica/junina/logo.svg",
        bg: "/tematica/default/bg.jpg"
      },
      {
        key: "recesso",
        link: null,
        logo: "/tematica/recesso/logo.png",
        bg: "/tematica/default/bg.jpg"
      },
      {
        key: "matricula",
        link: null,
        logo: "/tematica/matricula/logo.svg",
        bg: "/tematica/default/bg.jpg"
      },
      {
        key: "aniversario",
        link: null,
        logo: "/tematica/aniversario/logo.svg",
        bg: "/tematica/default/bg.jpg"
      },
      {
        key: "soumais",
        link: null,
        logo: "/tematica/soumais/logo.svg",
        bg: "/tematica/default/bg.jpg"
      }
    ]
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_USER_COMPANY(state, company) {
      state.user.company = company;
      state.user.active_company_id = company.id;
    }
  },
  actions: {
    // async doInit(context) {
    //   context.commit("SET_USER", await login.user(true, true));
    // },
  },
  getters: {
    modules: state => {
      return state.user && state.user.company
        ? state.user.company.modules
        : null;
    },
    materiais: state => (tipo = null) => {
      if (!tipo) {
        return state.materiais;
      }
      return state.materiais.filter(material => {
        return material.tipo === tipo;
      });
    },
    fotoPorSegmento: state => tipo => {
      switch (tipo) {
        case 1:
          return "/images/espaco/9.jpg";
        case 2:
          return "/images/espaco/2.jpg";
        default:
          return "/images/espaco/10.jpg";
      }
    },
    smallImages: state => (qtd = false) => {
      let result = [];
      IMAGES.forEach(function(image) {
        result.push(IMAGE_DIR + image + "t.jpg");
      });
      // return qtd > 0 ? result.slice(0, qtd) : result;
      return qtd > 0 ? result.slice(0, 6) : result;
    },
    bigImages: state => (qtd = false) => {
      let result = [];
      IMAGES.forEach(function(image) {
        result.push(IMAGE_DIR + image + ".jpg");
      });
      // return qtd > 0 ? result.slice(0, qtd) : result;
      return qtd > 0 ? result.slice(0, 6) : result;
    },
    campanhas: state => (big = false) => {
      let result = [];
      CAMPANHAS.forEach(function(campanha) {
        result.push(big ? campanha.big : campanha.image);
      });
      // return qtd > 0 ? result.slice(0, qtd) : result;
      return result;
    },
    outdoorLgs: state => {
      let result = [];
      state.outdoors.forEach(function(image) {
        result.push(image.lg);
      });
      return result;
    },
    outdoorSms: state => {
      let result = [];
      state.outdoors.forEach(function(image) {
        result.push(image.sm);
      });
      return result;
    },
    tematica: state => {
      return state.tematicas[5];
    }
  }
});
